import * as actionTypes from './actionTypes';

export const openModal = (nameModal: string) => ({
  type: actionTypes.OPEN_MODAL,
  nameModal
});

export const closeModal = () => ({
  type: actionTypes.CLOSE_MODAL
});
